export default "__VITE_ASSET__v$SyY6tD__"